import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SubNavigationMenuItemsList from '../../../navigation/menu-item/subitems-list';
import useHandleLinkClick from '../../../navigation/utils/use-handle-link-click';
import UserMenuButton from './user-menu-button';
import { MobileUserMenuPanel } from './styles';
const MobileUserMenu = ({ user, links, notifs }) => {
    const handleLinkClick = useHandleLinkClick({ selectedKeys: [] });
    return (_jsxs(MobileUserMenuPanel, { className: "user-menu", children: [_jsx(UserMenuButton, { user: user, isOnNav: true, notifs: notifs }), _jsx(SubNavigationMenuItemsList, { items: links, handleLinkClick: handleLinkClick, removeBorder: true })] }));
};
export default MobileUserMenu;
